function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.84 10.74c1.74-.063 3.48-.117 5.22-.209.75-.04 1.496-.095 2.243-.155.983-.082 1.962-.277 2.947-.168.308-.042.541-.24.701-.591.223-.464.366-.966.425-1.508a7.788 7.788 0 000-1.943l-.167-.843c-.109-.445-.303-.812-.584-1.101a7.207 7.207 0 00-3.168-.867 55.805 55.805 0 00-1.979-.044h-.3c-1.78.017-3.558.094-5.338.162-.363.052-.639.287-.829.702-.451.8-.574 1.976-.574 2.931a8.038 8.038 0 00.271 2.148c.173.582.532 1.508 1.133 1.486z",
  fill: "#3C94FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.208 21c2.092 0 3.713-.47 4.863-1.413 1.115-.977 1.673-2.337 1.673-4.081 0-1.082-.227-1.954-.68-2.617-.488-.697-1.185-1.238-2.091-1.622.697-.348 1.237-.82 1.62-1.412.384-.628.576-1.396.576-2.303 0-1.43-.488-2.564-1.464-3.4C13.729 3.383 12.317 3 10.47 3H3.882c-.523 0-.967.183-1.333.55A1.817 1.817 0 002 4.883V21h8.208zM9.79 9.96H5.555V6.14h4.183c1.01 0 1.69.14 2.039.418.418.314.627.802.627 1.465s-.209 1.151-.627 1.465c-.418.314-1.08.471-1.987.471zm-4.235 7.796h4.392c.976 0 1.725-.192 2.248-.576.488-.349.732-.942.732-1.779s-.244-1.447-.732-1.831c-.453-.349-1.22-.523-2.3-.523h-4.34v4.709z",
  fill: "#000"
});

function SvgBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgBlank;